/**
 * icon-stacker - the corner stack of action icons (feedback, assistant,
 * chat, help…), fixed to a viewport corner on every page, entry point.
 *
 * Three doors, one list:
 *   site config   'site' => ['iconStacker' => ['icons' => [...], 'layout' => 'vertical']]
 *                 → every page of the site (g.init hands it over)
 *   route.php     'iconStacker' => ['icons' => [...]]  → THIS page replaces
 *                 the list; 'iconStacker' => false hides the stack here
 *   JS            g.iconStacker.add({ name, icon, action });   // upsert by id
 *                 g.iconStacker.set([...]);                     // replace all
 *                 g.iconStacker.remove('feedback');
 *                 g.iconStacker.configure({ position: 'bottom-left', layout: 'horizontal', size: '2.5rem', sizeHover: '3.25rem' });
 *                 g.iconStacker.icons() / hide() / show() / version()
 *
 * An icon = { id?, name, icon: 'ri-…' | image: '<url>', action?: fn | url?: '<href>', target? }.
 * The name is the hover label + aria-label (translated through g.translate);
 * the click fires `icon-stacker:click` on document (cancelable), then runs
 * the action or follows the url. Sizes/position/layout are CSS variables on
 * the stack — the framework defaults, overridable per site, per page or at
 * runtime. The stack rests faded (opacity 0.1) and comes up to 1 as the
 * pointer approaches (from `reach` px down to `near` px); touch devices
 * see it at full opacity always. Full reference: docs/libs/icon-stacker.md.
 */
import { stacker, boot } from './icon-stacker.js';

// Bump on every meaningful change to the library.
const VERSION = '0.2.0';

stacker.version = () => VERSION;

if (window.g) {
	window.g.iconStacker = stacker;
	window.g.registerLib('icon-stacker');
} else {
	window.iconStacker = stacker; // genus not loaded (shouldn't happen in the template)
}

boot();
